import React, { useState } from 'react';
import {appModule} from 'services/module'
import {AppTable} from 'components/AppTable'
import {AppSearchInput} from 'components/AppFormItem'
import {Row,Col,Button} from 'antd'
import api, { MetadataEntity } from 'api'
import { AppTableAction } from 'components/AppAction'

export const EntityPageTable = () =>{
    const system = appModule.getCurrentModelingSystem();
    const [filter,setFilter] = useState({name:'',systemCode:system.code})

    const refTable = React.createRef<AppTable>();

    const onSearch = (value:string) =>{
        let newFilter = {...filter,name:value}
        setFilter(newFilter)
        refTable.current && refTable.current.queryGrid(newFilter);
    }

    return (
    <div style={{width:'100%',height:'100%',padding:20,minWidth:700,backgroundColor:'#ffffff'}}>
        <Row>
            <Col span={12}>
                <div style={{width:300}}>
                    <AppSearchInput placeholder='请输入表名（中文或英文名）' onSearch={(value:string)=>onSearch(value)}/>
                </div>
            </Col>
            <Col span={12}>
                <div style={{width:'100%',paddingLeft:30}}>
                    <Button type="dashed" icon="search" size='small'>
                        新增数据表
                    </Button>
                </div>
            </Col>
        </Row>
       
        <div style={{width:'100%',height:'calc(100% - 60px)',marginTop:20}}>
            <AppTable api={api.modeling.entity.getPageList}
                 data={filter}
                 ref={refTable}
                 paging
            >
                <AppTable.ColIndex />
                <AppTable.Col title="中文名" field="displayName" width={200} />
                <AppTable.Col title="英文名" field="name" width={200} />
                <AppTable.Col title="修改人" align="center" field="modifiedBy" width={200} />
                <AppTable.ColDate title="修改时间" field="modifiedOn" width={150} />
                <AppTable.ColAction align='center'
                    render={(data: MetadataEntity) => {
                        return (
                            <React.Fragment>
                                <AppTableAction
                                    // onClick={() => {
                                    //     this.editDataTable(data)
                                    // }}
                                    label="编辑"
                                />
                            </React.Fragment>
                        )
                    }}
                />
            </AppTable>
        </div>
    </div>
    )
}


// WEBPACK FOOTER //
// ./src/modules/modeling/entity/EntityPageTable.tsx